import { styled, withStyles, Tooltip } from '@material-ui/core';
import ButtonBase from '../BaseButton';

//Expecting more variants in the future.
const getColourFromVariant = (variant, theme) => {
  switch (variant) {
    case 'none':
      return {
        colour: 'inherit',
        hoverColour: 'inherit',
      };
    default:
      return {
        colour: theme.palette.xpl.secondary.default,
        hoverColour: theme.palette.xpl.secondary.default,
      };
  }
};

export const IconButtonComponent = styled(ButtonBase)(({ variant, theme }) => {
  const { colour, hoverColour } = getColourFromVariant(variant, theme);
  return {
    padding: 0,
    border: 0,
    backgroundColor: 'transparent',
    color: colour,
    minWidth: 0,
    minHeight: 0,
    width: 'fit-content',
    '&:hover': {
      color: hoverColour,
      // Helps remove sticky effect on mobile devices.
      '@media (hover: none)': {
        color: colour,
      },
    },
    '@media (hover: none)': {
      '&:focus': {
        color: hoverColour,
      },
    },
    '&[disabled]': {
      opacity: '0.5',
      pointerEvents: 'none',
    },
  };
});

//Expecting more variants.
const getTooltipBackgroundFromVariant = (variant, theme) => {
  switch (variant) {
    case 'none':
      return '';
    default:
      return theme.palette.xpl.secondary.default;
  }
};

export const TooltipComponent = withStyles((theme) => ({
  tooltip: {
    color: theme.palette.common.white,
    fontSize: '12px',
    borderRadius: '6px',
    padding: '6px 12px',
    backgroundColor: (props) =>
      getTooltipBackgroundFromVariant(props.buttonvariant, theme),
  },
  arrow: {
    color: (props) =>
      getTooltipBackgroundFromVariant(props.buttonvariant, theme),
  },
}))(Tooltip);
